module.exports = __webpack_public_path__ + "img/UMC-logo.13e36f4c.svg";